import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import {fetchUserToken, fetchShoppingCartItems} from "../../redux/actions";

class OrderDetail extends Component {
  constructor(props) {
    super(props);
		this.state = {
      loading: true,
      regionPrice:0
    }
  }

  componentDidMount() {
    if(_.isEmpty(this.props.userToken)){
      this.props.fetchUserToken().then(()=>{
        this.props.fetchShoppingCartItems(this.props.userToken);
      });
    } else {
      this.props.fetchShoppingCartItems(this.props.userToken);
    }

    this.setState({
      loading: false
    });
  }

  render() {
		if(this.state.loading) {
			return <div>Loading...</div>;
		}

    let shoppingCartItems = this.props.shoppingCartItems;
    let orderedList = [];
    let subTotalPrice = 0;
    //let deliveryPrice = 0;
    if (!_.isEmpty(shoppingCartItems)) {
      if (!shoppingCartItems.includes('empty')) {
        for (let i = 0; i < shoppingCartItems.length; i++){
          let orderedObject = shoppingCartItems[i].order;
          let orderedColor = Object.keys(orderedObject)[0];
          let orderedNum = orderedObject[orderedColor];
          let shoppingCartItemsUnitPrice = shoppingCartItems[i].totalPrice;
          let totalPrice = shoppingCartItemsUnitPrice;
          subTotalPrice += totalPrice;

          orderedList.push(
            <tr key={i}>
              <td className="OrderDetailSubSubCaption"> Item {i+1}</td>
              <td>{shoppingCartItems[i].product.name} </td>
              <td className="RightAlign"> x{orderedNum} </td>
            </tr>);
        }
      }
    }
    // if(this.props.region) this.setState({regionPrice:this.props.region})
    let totalPrice = subTotalPrice + this.props.region.regionPrice 
    return(
      <div className="OrderDetailSection">
        <div className="OrderDetailCaption">Order Detail</div>
        <table className="OrderDetailProductSection">
          <tbody>
              <tr className="OrderDetailSubCaption">
                <th colSpan="2">Product</th>
                <th className="RightAlign">Qty</th>
              </tr>
              {orderedList}
          </tbody>
        </table>

        <table className="OrderDetailPriceSection">
          <tbody>
            <tr className="OrderDetailSubCaption">
              <th  colSpan="2">Total</th>
              <th className="RightAlign">$ {totalPrice}</th>
            </tr>
            <tr className="OrderDetailPriceSub">
              <td>Sub-Total</td>
              <td className="RightAlign">$ {subTotalPrice}</td>
            </tr>
            <tr className="OrderDetailPriceSub">
              <td>Delivery Charges</td>
              <td className="RightAlign">$ {this.props.region.regionPrice}</td>
            </tr>
              
          </tbody>
        </table>

      </div>
    );
  }
}

function mapStateToProps(state){
  return({
    shoppingCartItems: state.shoppingCartItems,
    userToken: state.userToken,
    region: state.region
  });
}

export default connect(mapStateToProps, {fetchUserToken, fetchShoppingCartItems})(OrderDetail);



// WEBPACK FOOTER //
// ./src/components/orderPage2/orderDetail.js